export default {
  "content": "<path d=\"M20.668 2H12C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.478 10-10V3.332C22 2.596 21.404 2 20.668 2zm-1.39 9.161c0 .485-.39.875-.874.875h-5.565a.873.873 0 01-.875-.875V5.597c0-.485.39-.875.875-.875h5.565c.484 0 .875.39.875.875v5.564z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};